export default "__VITE_ASSET__b79cae3f__"